import { useState, useEffect } from "react";
import {
  Eye,
  FileText,
  ChevronUp,
  ChevronDown,
  Download,
  Bell,
  Wifi,
  MapPin,
  MoveLeft,
  MoveRight,
  ArrowRight,
  ArrowLeft,
  ChevronRight,
} from "lucide-react";
import styles from "../../styles/__insuranceDashboardPage.module.scss";
import { BiSolidChevronRightCircle } from "react-icons/bi";
import { PiPlusCircleFill, PiPlusCircleLight } from "react-icons/pi";
import { FiPlusCircle } from "react-icons/fi";
import PharmacyDashboardLayout from "../../components/pharamecy-dashboard-layout/PharamecyDashboardLayout";
import { CiFilter } from "react-icons/ci";
import { IoArrowForwardOutline } from "react-icons/io5";
import { MdInfo } from "react-icons/md";
import { Tooltip } from "bootstrap";

import UserImg from "../../assets/images/userBlkAvatar.png";
import BarLineChart from "../../assets/images/BarLineChart.png";

import { IoIosArrowDown } from "react-icons/io";
import {
  LiaAngleDownSolid,
  LiaAngleLeftSolid,
  LiaAngleRightSolid,
} from "react-icons/lia";
import { IoCalendarClearOutline } from "react-icons/io5";
import { LuUpload } from "react-icons/lu";
import { HiOutlineMagnifyingGlass } from "react-icons/hi2";

import InsuranceDashboardLayout from "../../components/insurance-dashboard-layout/InsuranceDashboardLayout";
import { BsChatText } from "react-icons/bs";

const InsuranceClaimHistoryDashboard = ({
  onLogout,
  onNavigateToAppointments,
}) => {
  const [activeTab, setActiveTab] = useState("All");
  const [sortField, setSortField] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");
  const [currentPage, setCurrentPage] = useState(1);
  const [isWalletDropdownOpen, setIsWalletDropdownOpen] = useState(false);

  const [itemsPerPage, setItemsPerPage] = useState(8);

  const appointments = [
    {
      id: 1,
      name: "Mohamed Hassan",
      location: "Online",
      date: "mm / dd / yyyy",
      time: "00:00 AM",
      typeIcon: "mic",
      type: "Online Consult",
      status: "Dispatched",
    },
    {
      id: 2,
      name: "Lyla Khalid",
      location: "Clinic Address",
      date: "mm / dd / yyyy",
      time: "00:00 AM",
      typeIcon: "",
      type: "On-Site",
      status: "Completed",
    },
    {
      id: 3,
      name: "Kamla Khalid",
      location: "Online",
      date: "mm / dd / yyyy",
      time: "00:00 PM",
      typeIcon: "video",
      type: "Online Consult",
      status: "In progress",
    },
    {
      id: 4,
      name: "Patient Name",
      location: "Online",
      date: "mm / dd / yyyy",
      time: "00:00 AM",
      typeIcon: "message",
      type: "Online Consult",
      status: "Rejected",
    },
    {
      id: 5,
      name: "Afra",
      location: "Clinic Address",
      date: "mm / dd / yyyy",
      time: "00:00 AM",
      typeIcon: "",
      type: "On-Site",
      status: "Dispatched",
    },
    {
      id: 6,
      name: "Mustafa",
      location: "Clinic Address",
      date: "mm / dd / yyyy",
      time: "00:00 AM",
      typeIcon: "",
      type: "On-Site",
      status: "Dispatch Ready",
    },
    {
      id: 7,
      name: "Sara Samir",
      location: "Clinic Address",
      date: "mm / dd / yyyy",
      time: "00:00 AM",
      typeIcon: "",
      type: "On-Site",
      status: "Rejected",
    },
    {
      id: 8,
      name: "Eline",
      location: "Clinic Address",
      date: "mm / dd / yyyy",
      time: "00:00 AM",
      typeIcon: "",
      type: "On-Site",
      status: "Pending Approval",
    },
    {
      id: 9,
      name: "Milad",
      location: "Clinic Address",
      date: "mm / dd / yyyy",
      time: "00:00 AM",
      typeIcon: "",
      type: "On-Site",
      status: "In progress",
    },
    {
      id: 10,
      name: "Lyla Khalid",
      location: "Clinic Address",
      date: "mm / dd / yyyy",
      time: "00:00 AM",
      typeIcon: "",
      type: "On-Site",
      status: "Accepted",
    },
    {
      id: 11,
      name: "Mohamed Hassan",
      location: "Online",
      date: "mm / dd / yyyy",
      time: "00:00 AM",
      typeIcon: "mic",
      type: "Online Consult",
      status: "Dispatched",
    },
    {
      id: 12,
      name: "Lyla Khalid",
      location: "Clinic Address",
      date: "mm / dd / yyyy",
      time: "00:00 AM",
      typeIcon: "",
      type: "On-Site",
      status: "Completed",
    },
    {
      id: 13,
      name: "Kamla Khalid",
      location: "Online",
      date: "mm / dd / yyyy",
      time: "00:00 PM",
      typeIcon: "mic",
      type: "Online Consult",
      status: "In progress",
    },
    {
      id: 14,
      name: "Patient Name",
      location: "Online",
      date: "mm / dd / yyyy",
      time: "00:00 AM",
      typeIcon: "mic",
      type: "Online Consult",
      status: "Rejected",
    },
    {
      id: 15,
      name: "Afra",
      location: "Clinic Address",
      date: "mm / dd / yyyy",
      time: "00:00 AM",
      typeIcon: "",
      type: "On-Site",
      status: "Dispatched",
    },
    {
      id: 16,
      name: "Mustafa",
      location: "Clinic Address",
      date: "mm / dd / yyyy",
      time: "00:00 AM",
      typeIcon: "",
      type: "On-Site",
      status: "Dispatch Ready",
    },
    {
      id: 17,
      name: "Sara Samir",
      location: "Clinic Address",
      date: "mm / dd / yyyy",
      time: "00:00 AM",
      typeIcon: "",
      type: "On-Site",
      status: "Rejected",
    },
    {
      id: 18,
      name: "Eline",
      location: "Clinic Address",
      date: "mm / dd / yyyy",
      time: "00:00 AM",
      typeIcon: "",
      type: "On-Site",
      status: "Pending Approval",
    },
    {
      id: 19,
      name: "Milad",
      location: "Clinic Address",
      date: "mm / dd / yyyy",
      time: "00:00 AM",
      typeIcon: "",
      type: "On-Site",
      status: "In progress",
    },
  ];

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
    setCurrentPage(1);
  };

  const filteredAppointments = appointments.filter((appointment) => {
    if (activeTab === "All") return true;
    if (activeTab === "Reschedule Requested")
      return appointment.status === "Reschedule Requested";
    return true;
  });

  const sortedAppointments = [...filteredAppointments].sort((a, b) => {
    if (!sortField) return 0;

    const aValue = a[sortField];
    const bValue = b[sortField];

    if (aValue < bValue) return sortDirection === "asc" ? -1 : 1;
    if (aValue > bValue) return sortDirection === "asc" ? 1 : -1;
    return 0;
  });

  const totalItems = sortedAppointments.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentAppointments = sortedAppointments.slice(startIndex, endIndex);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1);
  };

  const getSortIcon = (field) => {
    if (sortField !== field) return null;
    return sortDirection === "asc" ? <ChevronUp /> : <ChevronDown />;
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Upcoming":
        return "status2-upcoming";
      case "Completed":
        return "status2-completed";
      case "Cancelled":
        return "status2-cancelled";
      case "Reschedule Requested":
        return "status2-reschedule";
      case "Dispatched":
        return "status2-dispatched";
      case "Dispatch Ready":
        return "status2-dispatch-ready";
      case "Rejected":
        return "status2-rejected";
      case "Pending Approval":
        return "status2-pending-approval";
      case "In progress":
        return "status2-in-progress";
      case "Accepted":
        return "status2-accepted";
      default:
        return "";
    }
  };

  const handleNavigate = (page) => {
    if (page === "appointments") {
      onNavigateToAppointments();
    }
  };

  const toggleWalletDropdown = () => {
    setIsWalletDropdownOpen(!isWalletDropdownOpen);
  };

  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]',
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new Tooltip(tooltipTriggerEl);
    });
  }, []);

  const claimsStatusTableData = [
    {
      sNo: 1,
      claimId: "CLM-201",
      patientName: "Rahul Joshi",
      approveAmount: "-",
      claimStatus: <span className={styles["pendingStatus"]}>Pending</span>,
    },
    {
      sNo: 1,
      claimId: "CLM-201",
      patientName: "Rahul Joshi",
      approveAmount: "-",
      claimStatus: <span className={styles["pendingStatus"]}>Pending</span>,
    },
    {
      sNo: 1,
      claimId: "CLM-201",
      patientName: "Rahul Joshi",
      approveAmount: "-",
      claimStatus: <span className={styles["pendingStatus"]}>Pending</span>,
    },
    {
      sNo: 1,
      claimId: "CLM-201",
      patientName: "Rahul Joshi",
      approveAmount: "IQD 5,00,000",
      claimStatus: <span className={styles["successStatus"]}>Approved</span>,
    },
    {
      sNo: 1,
      claimId: "CLM-201",
      patientName: "Rahul Joshi",
      approveAmount: "IQD 5,00,000",
      claimStatus: <span className={styles["successStatus"]}>Approved</span>,
    },
    {
      sNo: 1,
      claimId: "CLM-201",
      patientName: "Rahul Joshi",
      approveAmount: "IQD 5,00,000",
      claimStatus: <span className={styles["successStatus"]}>Approved</span>,
    },
    {
      sNo: 1,
      claimId: "CLM-201",
      patientName: "Rahul Joshi",
      approveAmount: "IQD 5,00,000",
      claimStatus: <span className={styles["successStatus"]}>Approved</span>,
    },
    {
      sNo: 1,
      claimId: "CLM-201",
      patientName: "Rahul Joshi",
      approveAmount: "-",
      claimStatus: <span className={styles["rejectStatus"]}>Rejected</span>,
    },
    {
      sNo: 1,
      claimId: "CLM-201",
      patientName: "Rahul Joshi",
      approveAmount: "-",
      claimStatus: <span className={styles["rejectStatus"]}>Rejected</span>,
    },
    {
      sNo: 1,
      claimId: "CLM-201",
      patientName: "Rahul Joshi",
      approveAmount: "-",
      claimStatus: <span className={styles["rejectStatus"]}>Rejected</span>,
    },
  ];

  return (
    <>
      <InsuranceDashboardLayout
        currentPage="claimHistoryDash"
        onNavigate={handleNavigate}
        onLogout={onLogout}
      >
        {/* Appointments Section */}
        <div className={styles["db-section-header"]}>
          <h2>Claims for Doctor Consultation</h2>
        </div>

        <div className={styles["filterBar"]}>
          <label>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.953 2.25H19.047C19.714 2.25 20.284 2.25 20.74 2.307C21.223 2.368 21.69 2.505 22.074 2.865C22.464 3.232 22.619 3.689 22.687 4.164C22.75 4.601 22.75 5.144 22.75 5.764V6.54C22.75 7.029 22.75 7.45 22.714 7.803C22.674 8.183 22.589 8.538 22.383 8.879C22.178 9.218 21.903 9.464 21.585 9.684C21.286 9.892 20.905 10.107 20.455 10.36L17.513 12.016C16.843 12.393 16.61 12.529 16.454 12.664C16.097 12.974 15.892 13.319 15.796 13.75C15.755 13.935 15.75 14.167 15.75 14.873V17.605C15.75 18.506 15.75 19.271 15.657 19.86C15.559 20.485 15.33 21.085 14.73 21.46C14.143 21.827 13.498 21.793 12.87 21.644C12.265 21.501 11.52 21.209 10.626 20.86L10.54 20.826C10.12 20.662 9.754 20.519 9.464 20.369C9.152 20.208 8.862 20.008 8.641 19.696C8.416 19.38 8.327 19.042 8.286 18.696C8.25 18.381 8.25 18.003 8.25 17.581V14.873C8.25 14.167 8.246 13.935 8.204 13.75C8.11344 13.3241 7.88155 12.9414 7.546 12.664C7.39 12.529 7.156 12.393 6.487 12.016L3.545 10.36C3.095 10.107 2.714 9.892 2.415 9.684C2.097 9.464 1.822 9.218 1.617 8.879C1.411 8.538 1.326 8.182 1.287 7.803C1.25 7.451 1.25 7.029 1.25 6.54V5.764C1.25 5.144 1.25 4.601 1.313 4.164C1.381 3.689 1.536 3.232 1.926 2.865C2.31 2.505 2.776 2.368 3.26 2.307C3.716 2.25 4.286 2.25 4.953 2.25ZM3.448 3.796C3.114 3.838 3.008 3.906 2.953 3.959C2.903 4.005 2.839 4.086 2.797 4.377C2.752 4.695 2.75 5.129 2.75 5.815V6.505C2.75 7.039 2.75 7.383 2.778 7.649C2.804 7.896 2.848 8.015 2.902 8.104C2.957 8.195 3.049 8.298 3.27 8.452C3.504 8.614 3.823 8.795 4.31 9.069L7.223 10.709L7.303 10.754C7.863 11.069 8.243 11.283 8.529 11.531C9.10742 12.019 9.50823 12.6845 9.669 13.424C9.75 13.791 9.75 14.204 9.75 14.784V17.543C9.75 18.015 9.751 18.305 9.777 18.523C9.799 18.721 9.836 18.788 9.863 18.827C9.893 18.869 9.953 18.934 10.152 19.037C10.364 19.146 10.657 19.261 11.119 19.442C12.08 19.818 12.727 20.069 13.216 20.185C13.695 20.299 13.853 20.24 13.934 20.189C14.002 20.146 14.107 20.059 14.176 19.626C14.248 19.169 14.25 18.523 14.25 17.542V14.784C14.25 14.204 14.25 13.791 14.332 13.424C14.4925 12.6847 14.893 12.0191 15.471 11.531C15.757 11.283 16.138 11.068 16.696 10.754L16.777 10.709L19.69 9.069C20.177 8.795 20.496 8.614 20.73 8.452C20.951 8.298 21.043 8.195 21.098 8.104C21.152 8.015 21.196 7.896 21.221 7.649C21.249 7.383 21.25 7.039 21.25 6.504V5.814C21.25 5.129 21.248 4.694 21.203 4.377C21.161 4.086 21.096 4.005 21.048 3.959C20.992 3.907 20.886 3.838 20.552 3.796C20.202 3.751 19.727 3.75 19 3.75H5C4.273 3.75 3.799 3.751 3.448 3.796Z"
                fill="#2D2D37"
              />
            </svg>
            Filter
          </label>
          <div className={styles["filterWrapper"]}>
            <div className={styles["input-wrapper"]}>
              <input
                type="text"
                name="search"
                placeholder="Search company name,.."
              />
              <HiOutlineMagnifyingGlass className={styles["inputIcon"]} />
            </div>

            <div className={styles["select-wrapper"]}>
              <select>
                <option disabled selected>
                  Pending
                </option>
                <option>Pending</option>
                <option>Approved Approved</option>
                <option>Rejected</option>
                <option>Accepted</option>
              </select>
              <LiaAngleDownSolid className={styles["selectIcon"]} />
            </div>
            <div className={styles["input-wrapper"]}>
              <input type="text" placeholder="Date Range" />
              <IoCalendarClearOutline className={styles["inputIcon"]} />
            </div>
          </div>
          <button>Clear Filter</button>
          <button className={styles["exportBtn"]}>
            Export <LuUpload />
          </button>
        </div>

        <div className={styles["db-appointments-section"]}>
          <div className={styles["db-appointments-table"]}>
            <div className={"table-responsive"}>
              <table>
                <thead>
                  <tr>
                    <th>S. No.</th>
                    <th>Claim No.</th>
                    <th>Patient Name</th>
                    <th>Approved Amount</th>
                    <th>Claim Status</th>
                    <th>Documents</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {claimsStatusTableData.map((item, idx) => (
                    <tr key={idx}>
                      <td>{item.sNo}</td>

                      <td>{item.claimId}</td>
                      <td>{item.patientName}</td>
                      <td>{item.approveAmount || "-"}</td>
                      <td>{item.claimStatus}</td>

                      <td>
                        <div className={`${styles["db-action-buttons"]}`}>
                          <button
                            className={`${styles["db-view-btn"]}`}
                            title="Documents"
                          >
                            <span>Documents</span>
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5.14152 5.25755C5.553 4.84578 6.04159 4.51913 6.57936 4.29627C7.11714 4.07341 7.69356 3.9587 8.27568 3.9587C8.85781 3.9587 9.43423 4.07341 9.97201 4.29627C10.5098 4.51913 10.9984 4.84578 11.4099 5.25755C12.2414 6.0898 12.7085 7.21815 12.7085 8.39464C12.7085 9.57112 12.2414 10.6995 11.4099 11.5317L10.2182 12.7234C10.1043 12.8412 10.0412 12.9991 10.0426 13.1629C10.0439 13.3268 10.1096 13.4836 10.2254 13.5995C10.3412 13.7155 10.4979 13.7813 10.6618 13.7828C10.8257 13.7843 10.9836 13.7213 11.1015 13.6076L12.2932 12.4151C13.3591 11.3484 13.9578 9.90216 13.9578 8.39422C13.9578 6.88628 13.3591 5.44004 12.2932 4.37339C11.7656 3.84546 11.1392 3.42666 10.4497 3.14093C9.76023 2.8552 9.0212 2.70813 8.27485 2.70813C7.52851 2.70813 6.78947 2.8552 6.09999 3.14093C5.41051 3.42666 4.78408 3.84546 4.25652 4.37339L1.87318 6.76005C1.09826 7.53646 0.564354 8.52036 0.335789 9.59324C0.107224 10.6661 0.19375 11.7822 0.584941 12.807C0.976133 13.8319 1.6553 14.7217 2.54063 15.3694C3.42596 16.0171 4.47968 16.395 5.57485 16.4576C5.65682 16.4621 5.73888 16.4504 5.81634 16.4233C5.89381 16.3961 5.96516 16.3539 6.02633 16.2992C6.0875 16.2444 6.13729 16.1782 6.17285 16.1042C6.20842 16.0302 6.22906 15.9499 6.2336 15.868C6.23814 15.786 6.22649 15.7039 6.19932 15.6265C6.17215 15.549 6.12999 15.4777 6.07524 15.4165C6.02049 15.3553 5.95423 15.3055 5.88024 15.27C5.80625 15.2344 5.72598 15.2138 5.64402 15.2092C4.78954 15.1603 3.96742 14.8654 3.27671 14.3599C2.586 13.8545 2.05616 13.1602 1.75101 12.3605C1.44587 11.5609 1.37843 10.6901 1.55683 9.85302C1.73523 9.01593 2.15186 8.24829 2.75652 7.64255L5.14152 5.25755Z"
                                fill="#155DFC"
                              />
                              <path
                                d="M14.4248 3.54252C14.2593 3.53335 14.0969 3.59031 13.9734 3.70088C13.8498 3.81145 13.7753 3.96657 13.7661 4.13211C13.7569 4.29765 13.8139 4.46005 13.9244 4.58359C14.035 4.70713 14.1901 4.78168 14.3557 4.79086C15.2101 4.83977 16.0323 5.13471 16.723 5.64013C17.4137 6.14555 17.9435 6.8399 18.2487 7.63954C18.5538 8.43917 18.6213 9.30998 18.4429 10.1471C18.2645 10.9841 17.8478 11.7518 17.2432 12.3575L14.8582 14.7417C14.4467 15.1536 13.958 15.4803 13.4202 15.7033C12.8823 15.9262 12.3058 16.041 11.7236 16.041C11.1414 16.041 10.5648 15.9262 10.027 15.7033C9.48914 15.4803 9.0005 15.1536 8.589 14.7417C7.75769 13.9095 7.29075 12.7813 7.29075 11.605C7.29075 10.4287 7.75769 9.30057 8.589 8.46836L9.78067 7.27502C9.89107 7.15654 9.95117 6.99984 9.94831 6.83792C9.94545 6.676 9.87986 6.52152 9.76535 6.40701C9.65084 6.29249 9.49635 6.2269 9.33443 6.22404C9.17252 6.22119 9.01581 6.28129 8.89733 6.39169L7.70566 7.58419C6.63977 8.65084 6.04102 10.0971 6.04102 11.605C6.04102 13.113 6.63977 14.5592 7.70566 15.6259C8.23323 16.1538 8.85965 16.5726 9.54914 16.8583C10.2386 17.144 10.9777 17.2911 11.724 17.2911C12.4703 17.2911 13.2094 17.144 13.8989 16.8583C14.5883 16.5726 15.2148 16.1538 15.7423 15.6259L18.1257 13.2392C18.9003 12.4628 19.434 11.479 19.6624 10.4064C19.8908 9.33369 19.8043 8.21784 19.4133 7.1932C19.0222 6.16856 18.3433 5.27882 17.4582 4.63112C16.5732 3.98342 15.5198 3.60538 14.4248 3.54252Z"
                                fill="#155DFC"
                              />
                            </svg>
                          </button>
                        </div>
                      </td>

                      <td>
                        <div className={`${styles["db-action-buttons"]}`}>
                          <button
                            className={`${styles["db-view-btn"]}`}
                            title="View"
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M12 8.25C11.0054 8.25 10.0516 8.64509 9.34835 9.34835C8.64509 10.0516 8.25 11.0054 8.25 12C8.25 12.9946 8.64509 13.9484 9.34835 14.6516C10.0516 15.3549 11.0054 15.75 12 15.75C12.9946 15.75 13.9484 15.3549 14.6516 14.6516C15.3549 13.9484 15.75 12.9946 15.75 12C15.75 11.0054 15.3549 10.0516 14.6516 9.34835C13.9484 8.64509 12.9946 8.25 12 8.25ZM9.75 12C9.75 11.4033 9.98705 10.831 10.409 10.409C10.831 9.98705 11.4033 9.75 12 9.75C12.5967 9.75 13.169 9.98705 13.591 10.409C14.0129 10.831 14.25 11.4033 14.25 12C14.25 12.5967 14.0129 13.169 13.591 13.591C13.169 14.0129 12.5967 14.25 12 14.25C11.4033 14.25 10.831 14.0129 10.409 13.591C9.98705 13.169 9.75 12.5967 9.75 12Z"
                                fill="#155DFC"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M12 3.25C7.486 3.25 4.445 5.954 2.68 8.247L2.649 8.288C2.249 8.807 1.882 9.284 1.633 9.848C1.366 10.453 1.25 11.112 1.25 12C1.25 12.888 1.366 13.547 1.633 14.152C1.883 14.716 2.25 15.194 2.649 15.712L2.681 15.753C4.445 18.046 7.486 20.75 12 20.75C16.514 20.75 19.555 18.046 21.32 15.753L21.351 15.712C21.751 15.194 22.118 14.716 22.367 14.152C22.634 13.547 22.75 12.888 22.75 12C22.75 11.112 22.634 10.453 22.367 9.848C22.117 9.284 21.75 8.807 21.351 8.288L21.319 8.247C19.555 5.954 16.514 3.25 12 3.25ZM3.87 9.162C5.498 7.045 8.15 4.75 12 4.75C15.85 4.75 18.501 7.045 20.13 9.162C20.57 9.732 20.826 10.072 20.995 10.454C21.153 10.812 21.25 11.249 21.25 12C21.25 12.751 21.153 13.188 20.995 13.546C20.826 13.928 20.569 14.268 20.131 14.838C18.5 16.955 15.85 19.25 12 19.25C8.15 19.25 5.499 16.955 3.87 14.838C3.43 14.268 3.174 13.928 3.005 13.546C2.847 13.188 2.75 12.751 2.75 12C2.75 11.249 2.847 10.812 3.005 10.454C3.174 10.072 3.432 9.732 3.87 9.162Z"
                                fill="#155DFC"
                              />
                            </svg>
                          </button>
                          <BsChatText size={20} />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className={`${styles["db-pagination"]}`}>
            <span className={`${styles["db-pagination-info"]}`}>
              Showing 10 of 32
            </span>
            <div className={`${styles["db-pagination-controls"]}`}>
              <button
                className={`${styles["db-pagination-btn"]} ${
                  styles["prev-btn"]
                } ${currentPage === 1 ? styles["disabled"] : ""}`}
                onClick={handlePrevious}
                disabled={currentPage === 1}
              >
                <ArrowLeft /> Previous
              </button>

              <div className={`${styles["db-page-numbers"]}`}>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                  (page) => (
                    <button
                      key={page}
                      className={`${styles["db-page-btn"]} ${
                        currentPage === page ? styles["active"] : ""
                      }`}
                      onClick={() => handlePageChange(page)}
                    >
                      {page}
                    </button>
                  ),
                )}
              </div>

              <button
                className={`${styles["db-pagination-btn"]} ${
                  styles["db-next-btn"]
                } ${currentPage === totalPages ? styles["disabled"] : ""}`}
                onClick={handleNext}
                disabled={currentPage === totalPages}
              >
                Next <ArrowRight />
              </button>
            </div>
          </div>
        </div>
      </InsuranceDashboardLayout>
    </>
  );
};

export default InsuranceClaimHistoryDashboard;
